export default function nullSafeItems<T>(items: (T | null | undefined)[]): T[] {
  return items.filter((item) => item) as T[];
}
